module.exports = __webpack_public_path__ + "img/exam.3932fa88.svg";